import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "text-blue-700" };
import { computed } from 'vue';
import { I18nInfo } from '@/user/models';
import moment from 'moment';
import { parseCurrency } from '@/user/helpers/util';
import { Modal, ModalFooter, FilledButton } from '@/user/components/common';
import clsx from 'clsx';
import store from '@/user/store';
const DATE_FORMAT = 'YYYY.MM.DD HH:mm';
export default /*@__PURE__*/ _defineComponent({
    __name: 'CertificationExamCancelModal',
    props: {
        modelValue: { type: Boolean },
        exam: {}
    },
    emits: ["update:modelValue", "cancel-exam"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value),
        });
        const t_common = new I18nInfo('common');
        const t = new I18nInfo('certification.applied.modal.cancel');
        const styles = {
            wrapper: '',
            titleDesc: clsx('block text-title-2 py-4'),
            note: clsx('text-body-5 text-gray-800', 'desktop:py-4'),
            tableCover: clsx('w-full border-1 border-gray-250 rounded-12 overflow-hidden mt-16'),
            table: 'w-full [&>thead>th:first-child]:border-l-0 [&>tbody>tr>td:first-child]:border-l-0',
            th: clsx('w-110 px-23 py-16 text-body-3 bg-gray-150 border-gray-250 border-l-1 text-center [&:first-child]:w-206'),
            td: clsx('px-24 py-17 border-gray-200 border-l-1 text-body-5 text-center [&:first-child]:w-206'),
        };
        function showCancelConfirmation() {
            store.dispatch('AlertStore/showAlertModal', {
                message: t.translate('confirm'),
                onConfirm: handleCancelExam,
            });
        }
        const handleCancelExam = () => {
            emit('cancel-exam', props.exam);
            isOpen.value = false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                size: "large",
                title: _unref(t).translate('title')
            }, {
                content: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_unref(t).translate('note.desc1')), 1),
                    _createElementVNode("div", {
                        class: _normalizeClass(styles.tableCover)
                    }, [
                        _createElementVNode("table", {
                            class: _normalizeClass(styles.table)
                        }, [
                            _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
                                _createElementVNode("col", { width: "270" }),
                                _createElementVNode("col", { width: "120" }),
                                _createElementVNode("col", { width: "160" }),
                                _createElementVNode("col", { width: "120" })
                            ], -1)),
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('examName')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('level')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('paidAt')), 3),
                                    _createElementVNode("th", {
                                        class: _normalizeClass(styles.th)
                                    }, _toDisplayString(_unref(t).translate('amount')), 3)
                                ])
                            ]),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", {
                                        class: _normalizeClass(styles.td)
                                    }, _toDisplayString(props.exam.examName), 3),
                                    _createElementVNode("td", {
                                        class: _normalizeClass(styles.td)
                                    }, [
                                        _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t_common).translate(`certification.enums.level.${props.exam.level}`)), 1)
                                    ], 2),
                                    _createElementVNode("td", {
                                        class: _normalizeClass(styles.td)
                                    }, _toDisplayString(_unref(moment)(props.exam.appliedAt).format(DATE_FORMAT)), 3),
                                    _createElementVNode("td", {
                                        class: _normalizeClass(styles.td)
                                    }, _toDisplayString(_unref(parseCurrency)(props.exam.amount)), 3)
                                ])
                            ])
                        ], 2)
                    ], 2)
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(ModalFooter), null, {
                        default: _withCtx(() => [
                            _createVNode(_unref(FilledButton), {
                                class: "desktop:w-auto w-full",
                                color: "blue",
                                "desktop-size": "large",
                                "mobile-size": "medium",
                                onClick: showCancelConfirmation
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t).translate('title')), 1)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["modelValue", "title"]));
        };
    }
});
